import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from "react";
export const CheckoutContext = createContext({
    customerShippingAddresses: undefined,
    setCustomerShippingAddresses: () => { },
    orderInfo: undefined,
    setOrderInfo: () => { },
    isPayLaterSelected: false,
    setIsPayLaterSelected: () => { },
    isDeliveryMethodSelected: false,
    setIsDeliveryMethodSelected: () => { },
    resetContext: () => { },
});
export const CheckoutContextProvider = ({ children }) => {
    const [customerShippingAddresses, setCustomerShippingAddresses] = useState();
    const [orderInfo, setOrderInfo] = useState();
    const [isPayLaterSelected, setIsPayLaterSelected] = useState(false);
    const [isDeliveryMethodSelected, setIsDeliveryMethodSelected] = useState(false);
    const resetContext = () => {
        setCustomerShippingAddresses(undefined);
        setOrderInfo(undefined);
        setIsPayLaterSelected(false);
        setIsDeliveryMethodSelected(false);
    };
    return (_jsx(CheckoutContext.Provider, Object.assign({ value: {
            customerShippingAddresses,
            setCustomerShippingAddresses,
            orderInfo,
            setOrderInfo,
            isPayLaterSelected,
            setIsPayLaterSelected,
            isDeliveryMethodSelected,
            setIsDeliveryMethodSelected,
            resetContext,
        } }, { children: children })));
};
